module.exports = __webpack_public_path__ + "img/lpsc.fabe74fb.jpg";